import { createI18n } from 'vue-i18n'

import { ECM, type UserModule } from '~/types'

// Import i18n resources
// https://vitejs.dev/guide/features.html#glob-import
const messages = Object.fromEntries(
  Object.entries(
    import.meta.glob<{ default: any }>('../../locales/*.y(a)?ml', { eager: true }),
  )
    .map(([key, value]) => {
      const yaml = key.endsWith('.yaml')
      return [key.slice(14, yaml ? -5 : -4), value.default]
    }),
)

const SUPPORTED_LOCALES = Object.values(ECM.Locale) as string[]

function getSupportedLocale(browserLang: string): ECM.Locale {
  const detectedLang = browserLang.split('-')[0].toLowerCase()
  return SUPPORTED_LOCALES.includes(detectedLang)
    ? detectedLang as ECM.Locale
    : ECM.Locale.EN
}

export const install: UserModule = ({ app, isClient, router }) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    fallbackLocale: ECM.Locale.EN,
    messages,
  })

  if (isClient)
    i18n.global.locale.value = getSupportedLocale(navigator.language)
  else
    i18n.global.locale.value = ECM.Locale.EN

  router.afterEach((to) => {
    if (to.params.locale && Object.values(ECM.Locale).includes(to.params.locale as any))
      i18n.global.locale.value = to.params.locale as ECM.Locale
  })

  app.use(i18n)
}
